// extracted by mini-css-extract-plugin
export default {"imagePreview":"Mqx70F0i_c"};